import React from 'react';
import { number } from 'prop-types';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import { styled } from '@mui/material/styles';
// Components
const BoxStyles = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: 74,
  justifyContent: 'flex-start',
  margin: theme.spacing(1, 'auto', 0),
}));

const ProgressIcon = styled(CircularProgress)(({ theme }) => ({
  marginRight: theme.spacing(1.5),
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontWeight: 700,
  marginTop: theme.spacing(2),
}));

const SubmitProgressHeader = ({ totalProgress }) => {
  const theme = useTheme();
  return (
    <BoxStyles>
      {totalProgress === 100 ? (
        <>
          <CheckRoundedIcon sx={{ color: theme.palette.secondary.main, height: 48, width: 48 }} />
          <Title color="inherit" variant="h6">
            Success!
          </Title>
        </>
      ) : (
        <>
          <ProgressIcon color="secondary" size={56} />
          <Title color="inherit" variant="h6">
            Processing. . .
          </Title>
        </>
      )}
    </BoxStyles>
  );
};

SubmitProgressHeader.propTypes = {
  totalProgress: number.isRequired,
};

export default SubmitProgressHeader;
